import { Container, Text } from 'pixi.js';
import { listen, type Scene } from './scene.js';
import { Button } from './view/button.js';

const WIDTH = 420;

/**
 * Экран запуска: загрузка аккаунта и контента с сервера. Без сервера игра не запускается —
 * экран «Нет соединения» с повтором (SPEC.md, 17.4).
 */
export class ConnectScene implements Scene {
  readonly view = new Container();
  private readonly message = new Text({
    text: 'Подключение к лаборатории…',
    style: {
      fill: 0xf2fbff,
      fontFamily: 'system-ui, sans-serif',
      fontSize: 22,
      align: 'center',
      wordWrap: true,
      wordWrapWidth: WIDTH,
    },
  });
  private readonly retry: Button;
  private readonly unsubscribe: (() => void)[] = [];

  constructor(onRetry: () => void) {
    this.message.anchor.set(0.5, 0);
    this.message.position.set(WIDTH / 2, 0);
    this.retry = new Button({ label: 'Повторить', width: 200, onTap: onRetry });
    this.retry.position.set((WIDTH - 200) / 2, 110);
    this.retry.visible = false;
    this.view.addChild(this.message, this.retry);
    this.unsubscribe.push(listen('resize', () => this.layout()));
    this.layout();
  }

  connecting(): void {
    this.message.text = 'Подключение к лаборатории…';
    this.retry.visible = false;
  }

  failed(offline: boolean): void {
    this.message.text = offline
      ? 'Нет соединения\nПроверьте интернет и попробуйте ещё раз.'
      : 'Нет соединения\nСервер недоступен. Попробуйте ещё раз.';
    this.retry.visible = true;
  }

  private layout(): void {
    const scale = Math.min(1, (window.innerWidth - 32) / WIDTH);
    this.view.scale.set(scale);
    this.view.position.set(
      (window.innerWidth - WIDTH * scale) / 2,
      window.innerHeight / 2 - 80 * scale,
    );
  }

  destroy(): void {
    this.unsubscribe.forEach((off) => off());
    this.view.destroy({ children: true });
  }
}
